import { render, staticRenderFns } from "./game.vue?vue&type=template&id=53090ca0&scoped=true&"
import script from "./game.vue?vue&type=script&lang=ts&"
export * from "./game.vue?vue&type=script&lang=ts&"
import style0 from "./game.vue?vue&type=style&index=0&id=53090ca0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53090ca0",
  null
  
)

export default component.exports